var user_agent = navigator.userAgent.toLowerCase(); // mirem el user agent
window.click_o_touch = user_agent.match(/(iphone|ipod|ipad)/) ? "touchstart" : "click"; //si son IOS fem touch en lloc de clic!

window.log = false;

window.deletedItems = false;

/* utilitzats en font-filter */
window.mstyleoption = 'All';
window.musageoption = 'All';


$(document).ready(function (e) {


    $(function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            contentType: "application/json"
        });

    });


    $(document).on(window.click_o_touch, "#open-menu-mobile", function (e) {
        e.preventDefault();
        $('#menu-mobile').slideToggle();
    })


    /****** MASTER ***DOCREADY****/
    //fa que el paste no copii formats a contenteditable
    $('[contenteditable]').on('paste', function (e) {
        e.preventDefault();
        var text = (e.originalEvent || e).clipboardData.getData('text/plain');
        document.execCommand('insertText', false, text);
    });


    $(document).on(window.click_o_touch, ".closeTheModal", function (e) {
        $('#theModal').fadeOut();
    });

    $(document).on(window.click_o_touch, ".modalCart", function (e) {
        e.preventDefault();
        /*si som a XS o SM carreguem directament /cart */
        if (wearein('xs') || wearein('sm')) {
            window.location.href = "/cart";
        } else {
            toggleModalCart($(this).data('url'));
        }
    });


    $(document).on(window.click_o_touch, ".closeModal", function (e) {

        e.preventDefault();

        var theLayer = $("#theModal");
        var theContent = theLayer.find(".theColumn");

        if (theLayer.is(':visible')) {

            theContent.html('');
            theLayer.fadeOut();
            removeTriFo();

            daltMenu();

        }
    });

    /* utilitzat a loginfilter*/
    $(document).on(window.click_o_touch, ".show-register", function (e) {
        e.preventDefault();
        var rf = $('.register-form');
        if (rf.is(':visible')) {
            rf.fadeOut();
        } else {
            rf.fadeIn();
        }
    });


    /* modal cart */

    $(document).on(window.click_o_touch, ".btn-deleteRowInfo", function (e) {

        var idrow = $(this).closest('div.infoline').find('input[name=rowid]').val();
        deleteRowInfo(idrow);
    });


    /* amaguem modal en clicar fora */
    $(document).click(function (event) {
        /* mirem q no siguem dins!*/
        if (!$(event.target).closest('.cartinfo-area').length) {
            if ($('#cartModal').is(":visible")) {
                $('#cartModal').fadeOut();
                if (window.deletedItems && (window.wally == 'catalogue' || window.wally == 'cart')) {
                    location.reload();
                }
            }
        }
    });


    $(document).on(window.click_o_touch, ".close-modal", function (e) {
        e.preventDefault();
        $('.modal').hide();
    })


    /* OWLS DE HOME PAGE */

    var midaFletxa = ($("#div-xs").is(":visible") || $("#div-sm").is(":visible")) ? "30px" : "45px";


    var $owl = $(".owl-carousel.loop");

    // El primer slide es random entre la quantitat maxima d'slides que tenen a data-firstslide
    var firstSlide = 0;
    var arSlideSizes = [];

    $owl.each(function () {
        var slideSize = parseInt($(this).attr('data-totalslides'));
        if(slideSize){
            arSlideSizes.push(slideSize);
        }
    });

    var maxSlide = Math.max.apply(Math, arSlideSizes);
    firstSlide = Math.floor((Math.random() * maxSlide) + 1); //random entre 1 i el maxSlide

    $owl.owlCarousel({
        nav: true, // Show next and prev buttons
        navText: [
            '<span style="font-size: ' + midaFletxa + ';" class="navarrow font-gray icon-Arrow_Med_Left"></span>',
            '<span style="font-size: ' + midaFletxa + ';" class="navarrow font-gray icon-Arrow_Med_Right"></span>'
        ],
        dots: false,
        items: 1,
        loop: true,
        startPosition: firstSlide
    });



    $(".owl-carousel.noloop").owlCarousel({
        nav: true, // Show next and prev buttons
        navText: [
            '<span style="font-size: ' + midaFletxa + ';" class="navarrow font-gray icon-Arrow_Med_Left"></span>',
            '<span style="font-size: ' + midaFletxa + ';" class="navarrow font-gray icon-Arrow_Med_Right"></span>'
        ],
        dots: false,
        items: 1,
        loop: false,
    });


})


/****** FUNCIONS A MASTER **********/


/**
 *
 * els elements amb .modalLayer han de tenir un atribut url
 * que defineix el mètode q s'invocarà
 *
 * ex) deleteRow es fa així
 * <span class="pointer btn-deleteRow modalLayer" url="/cart/ask-delete-row?rowid={ {$item->rowid} }" ><span class="emsvg-close"></span></span>
 *
 * en clicar-hi es mostra dins la capa theModal la resposta de la url, en aquest cas la que dona el mètode de cartcontroller:
 *
 *     function getAskDeleteRow()
 *      {
     *      $rowid = Input::get('rowid');
     *      $view = View::make($this->baseroute . '.parts.modal-delete-row', compact('rowid'));
     *      return $view->render();
     *      }
 *
 * un cop es substitueix el html de dins la Layer (theColumn) la cosa ja depèn de què s'hi digui
 *
 */



function daltMenu() {
    $(".top-toggle-icons").addClass('no-visible');
    $(".top-toggle-menu").removeClass('no-visible');

}

function daltCreu() {
    $(".top-toggle-icons").addClass('no-visible');
    $(".top-toggle-creu").removeClass('no-visible');
}

function daltCreuF() {
    $(".top-toggle-icons").addClass('no-visible');
    $(".top-toggle-creuf").removeClass('no-visible');
}


$(document).on(window.click_o_touch, ".modalLayer", function (e) {

    var prevent = !$(this).hasClass('noPrevent');
    if (prevent) {
        e.preventDefault();
    }
    var force = $(this).hasClass('force');
    var info = $(this).attr('url');
    window.afterUrl = $(this).data('after');

    var classmovetrifo = $(this).hasClass('movetrifo');
    showInLayer(info, force, classmovetrifo);
});


/**
 * funcio proces modal, creada per poder ser cridada independentment de l'event q llança el click
 *
 * @param info
 * @param prevent
 * @param force
 * @param classmovetrifo
 */
function showInLayer(info, force, classmovetrifo) {
    daltCreu();

    force = typeof force !== 'undefined' ? force : false;
    classmovetrifo = typeof classmovetrifo !== 'undefined' ? classmovetrifo : false;


    //si tenim class=force passem de layer actual, directament la tanquem i executem el q calgui
    //var force= $(this).hasClass('force');


    var theLayer = $("#theModal");
    var theContent = theLayer.find(".theColumn");
    //var info = $(this).attr('url');
    var saltem = force;


    //mirem si som a mobile!!!
    //var som_mobile=($('ul#menu-mobile').length);
    var moureTrifo = !wearein('xs');

    if (window.log) console.log("Cridem..." + info);


    // ull! mirem si existeix page dins de theLayer
    // si es així mirem que no estiguem intentant obrir una pagina diferent
    // de la que esta ara oberta
    // en aquest cas tanquem la que hi ha oberta i saltem a obrir la que toca

    var page = $('input[name=page]', theLayer);

    if (page.length) {
        if (window.log) console.log(page.val());
        if (page.val() != info) {
            theContent.html('');
            //theLayer.fadeOut();

            //nomes movem trifo si NO som a mobile
            if (moureTrifo) {
                if ($("#site-credits-page").length) {
                    moveTriFo($("#site-credits-link"));
                } else if ($("#licensing-page").length) {
                    moveTriFo($("#licensing-link"));
                } else if ($("#terms-page").length) {
                    moveTriFo($("#terms-link"));
                } else if ($("#faq-page").length) {
                    moveTriFo($("#faq-link"));
                } else {
                    removeTriFo();
                }
            }
            saltem = true;
        }
    }


    //si info es /contact o /subscription posem el triangle

    if (classmovetrifo && moureTrifo) {
        moveTriFo(info);
    }


    if (!saltem && theLayer.is(':visible')) {

        theContent.html('');
        //theLayer.fadeOut();

        //nomes movem trifo si NO som a mobile
        if (moureTrifo) {
            if ($("#site-credits-page").length) {
                moveTriFo($("#site-credits-link"));
            } else if ($("#licensing-page").length) {
                moveTriFo($("#licensing-link"));
            } else {
                removeTriFo();
            }
        }


    } else {

        var footer = $('.footer-area');

        //var final = $('#theEnd');
        //theLayer.css("height", footer.offset().top - 60 - 60 + footer.outerHeight());
        //console.log("alt: "+ (footer.offset().top - 60 + footer.outerHeight()));

        var alt_footer = footer.offset().top - 60 + footer.outerHeight();
        var alt_content = ($('#theContent').css('height').match(/\d+/)[0] * 1) + 60;
        var alt_final = (alt_footer > alt_content) ? alt_footer : alt_content;

        theLayer.css('min-height', alt_final + 'px'); //60 es espai entre footer i final content
        $.ajax({
            method: 'GET',
            url: info,
            data: {frompage: window.location.href},
            contentType: 'application/x-www-form-urlencoded',
            success: function (r) {
                if (r != 'error') {
                    theContent.html(r);
                    $("html, body").animate({scrollTop: 0}, "fast");
                    theLayer.fadeIn();
                }
            }
        });
    }
    return;
}


$(document).on(window.click_o_touch, ".____modalLayer", function (e) {

    daltCreu();

    if (!$(this).hasClass('noPrevent'))
        e.preventDefault();

    //si tenim class=force passem de layer actual, directament la tanquem i executem el q calgui
    var force = $(this).hasClass('force');


    var theLayer = $("#theModal");
    var theContent = theLayer.find(".theColumn");
    var info = $(this).attr('url');
    var saltem = force;


    //mirem si som a mobile!!!
    //var som_mobile=($('ul#menu-mobile').length);
    var moureTrifo = !wearein('xs');

    if (window.log) console.log("Cridem..." + info);


    // ull! mirem si existeix page dins de theLayer
    // si es així mirem que no estiguem intentant obrir una pagina diferent
    // de la que esta ara oberta
    // en aquest cas tanquem la que hi ha oberta i saltem a obrir la que toca

    var page = $('input[name=page]', theLayer);

    if (page.length) {
        if (window.log) console.log(page.val());
        if (page.val() != info) {
            theContent.html('');
            //theLayer.fadeOut();

            //nomes movem trifo si NO som a mobile
            if (moureTrifo) {
                if ($("#site-credits-page").length) {
                    moveTriFo($("#site-credits-link"));
                } else if ($("#licensing-page").length) {
                    moveTriFo($("#licensing-link"));
                } else {
                    removeTriFo();
                }
            }
            saltem = true;
        }
    }


    //si info es /contact o /subscription posem el triangle

    if ($(this).hasClass('movetrifo') && moureTrifo) {
        moveTriFo(info);
    }


    if (!saltem && theLayer.is(':visible')) {

        theContent.html('');
        //theLayer.fadeOut();

        //nomes movem trifo si NO som a mobile
        if (moureTrifo) {
            if ($("#site-credits-page").length) {
                moveTriFo($("#site-credits-link"));
            } else if ($("#licensing-page").length) {
                moveTriFo($("#licensing-link"));
            } else {
                removeTriFo();
            }
        }


    } else {

        var footer = $('.footer-area');

        //var final = $('#theEnd');
        //theLayer.css("height", footer.offset().top - 60 - 60 + footer.outerHeight());
        //console.log("alt: "+ (footer.offset().top - 60 + footer.outerHeight()));

        var alt_footer = footer.offset().top - 60 + footer.outerHeight();
        var alt_content = ($('#theContent').css('height').match(/\d+/)[0] * 1) + 60;
        var alt_final = (alt_footer > alt_content) ? alt_footer : alt_content;

        theLayer.css('min-height', alt_final + 'px'); //60 es espai entre footer i final content
        $.ajax({
            method: 'GET',
            url: info,
            data: {frompage: window.location.href},
            contentType: 'application/x-www-form-urlencoded',
            success: function (r) {
                if (r != 'error') {
                    theContent.html(r);
                    $("html, body").animate({scrollTop: 0}, "fast");
                    theLayer.fadeIn();
                }
            }
        });
    }
    return;
});


function toggleModalCart(info, force) {

    if (typeof force == 'undefined') {
        force = false;
    }

    var theLayer = $("#cartModal");
    var theContent = theLayer.find(".theColumn");

    var was_visible = (theLayer.is(':visible'));


    if (!force && was_visible) {

        theContent.html('');
        theLayer.fadeOut();

    }

    if (force || !was_visible) {


        $.ajax({
            method: 'GET',
            url: info,
            contentType: 'application/x-www-form-urlencoded',
            success: function (r) {
                if (r != 'error') {
                    theContent.html(r);
                    theLayer.fadeIn();
                }
            }
        });
    }
}


/**
 * situa el triangle sota menu en el seu lloc
 */
function mouTri() {

    $('#tri-marker').css('left', -100);
    $('#tri-marker-caption').css('left', -100);

    var $this = $(".active-item");
    if ($this) {
        var offset = $this.offset();
        if (offset) {
            var width = $this.width();
            var centerX = offset.left + width / 2;
            $('#tri-marker').css('left', centerX - 10);
        }
    }

    var $that = $("#captiontext");
    if ($that) {
        var offset = $that.offset();
        if (offset) {
            var width = $that.width();
            var centerX = offset.left + width / 2;
            $('#tri-marker-caption').css('left', centerX - 10);
        }
    }

}

function deleteRowInfo(idrow) {
    //console.log("anem a esborrar " + idrow);
    window.deletedItems = true;
    $.ajax({
        method: 'POST',
        url: "/cart/delete-row",
        contentType: 'application/x-www-form-urlencoded',
        data: {rowid: idrow},
        success: function (r) {
            //if (window.log) console.log("deleted");
            toggleModalCart($('.modalCart').data('url'), true);
            updBadges(-1);
        }
    });
}


/**** FUNCIONS COMUNS ******/



$(document).on(window.click_o_touch, '.showCartExtra', function () {
    $(this).closest('div.itembox').find('div.extraInfo').toggleClass('hidden-xs');

});


function addBundleToCart(bundleid, complerta) {

    var ccc = 0;

    if (typeof complerta !== 'undefined') {
        ccc = (complerta) ? 1 : 0;
    }
    ;

    $("li.buy-bundle" + bundleid).html('<a href="/cart" class="font-hover font-md font-bold">IN CART</a>');

    $.ajax({
        method: 'POST',
        url: "/cart/add-bundle-to-cart",
        contentType: 'application/x-www-form-urlencoded',
        data: {bundle: bundleid, complete: ccc},
        dataType: 'json'
    })
        .done(function (r) {
            //cambien tots per /cart
            if (window.log) console.log('buybundle...');
            updBadges(JSON.parse(r).qtt);
        });
}


function addFontToCart(fontid) {
    if (window.log) console.log('iniciant crida ajax per ...' + fontid);


    $('li.buy-href.font' + fontid).html('<a href="/cart" class="font-hover font-md font-bold">IN CART</a>');

    $.ajax({
        method: 'POST',
        url: "/cart/add-to-cart",
        contentType: 'application/x-www-form-urlencoded',
        data: {font: fontid},
        dataType: 'json'
    })
        .done(function (r) {
            if (window.log) console.log('crida ajax retorna: ');
            if (window.log) console.log(r);
            updBadges(r.qtt);
        });

}

/**
 * actualitza badges amb qtt
 * si qtt==-1 resta un
 * @param qtt
 */
function updBadges(qtt) {
    if (window.log) console.log('afegit! ' + qtt);

    if (qtt == -1) {
        qtt = $(".badge").text() * 1;
        qtt--;
    }

    if (qtt == 0) {
        $(".badge").text(qtt).css('visibility', 'hidden').closest(".badge-container").find(".badge-icon").css('color', 'black');
    } else {
        $(".badge").text(qtt).css('visibility', 'visible').closest(".badge-container").find(".badge-icon").css('color', '#e95022');
    }

}


/* **** emtypewrap *** */

$(document).on(window.click_o_touch, '.emtypeSelectMesInfo', function (e) {

    var theWrap = $(this).closest('div.emtypeWrapper').find('.emtypeSelectWrap');

    if (theWrap.is(':visible')) {
        $(".emtypeSelectWrap").hide(); //amaguem tots
        $(this).find('.emtypeSelectPointer').show();

    }
    else {
        $(".emtypeSelectWrap").hide(); //amaguem tots
        theWrap.toggle(); //mostrem aquest
        if (!$('#div-xs').is(':visible')) {
            $(this).find('.emtypeSelectPointer').hide();
        }
    }

    $(this).closest('div.emtypeWrapper').find('.emicon').toggleClass('nodisplay');
    $(this).find('.emtypeSelectPointer .up-down').toggleClass('ocult');

});


$(document).on("mouseenter", ".mostraover", function (e) {
    $(this).find('.emicon').removeClass('ocult');
    $(this).find('.svg').removeClass('ocult');

})

$(document).on("mouseleave", ".mostraover", function (e) {
    $(this).find('.svg').addClass('ocult');
    $(this).find('.emicon').addClass('ocult');
    $(this).find('.emtypeSelectWrap').hide();
})

$(document).on("mouseleave", ".hideleave", function (e) {
    $(this).hide();
})


/** amaga panell lateral en qualsevol clik */

$(document).click(function (event) {

    if (!$(event.target).hasClass('showinfo') && !$(event.target).closest('#infodivn').length &&
        !$(event.target).is('#infodivn')) {
        if ($('#infodivn').is(":visible")) {
            $('#infodivn').hide();
            if (window.log) console.log('amagant infodivn');
        }
    }

});

/********* mostra/amaga panell lateral **************/
/**** responsiu: si estem en XS el comportament és diferent: mostrem contingut en vista superposada modal */

$(document).on(window.click_o_touch, '.showinfo', function (e) {

    e.preventDefault();

    if ($("#div-xs").is(':visible')) {
        if (window.log) console.log('algo hem de fer');

        var theLayer = $("#theModal");
        var theContent = theLayer.find(".theColumn");

        //theContent.fadeOut();

        var ct = $("#infodivn").html();

        theContent.html('');
        theContent.html(ct);

        //theContent.fadeIn();


    } else {
        $('#infodivn').css('left', $(this).offset().left - 25);
        $('#infodivn').show();
    }


});

$(document).on(window.click_o_touch, '.hideinfo', function (e) {
    e.preventDefault();
    $('#infodivn').hide();
})


/* recover password IGUAL Q EMTYPE */

$(document).on(window.click_o_touch, ".recover_password_email", function (e) {
    e.preventDefault();
    if ((formcheck('resetEmailForm'))) {
        recover_password_email();
    }
});


$(document).on("keypress", "input", function (e) {

    if ($(this).hasClass('form_alert')) {
        $(this).removeClass('form_alert');
        $(this).siblings('label').removeClass('form_alert');
    }

});


function recover_password_email() {
    $('#form-div').hide();
    $('#sent-div').fadeIn();

    var token = $('meta[name=csrf-token]').attr("content")

    $.ajax({
        method: 'POST',
        url: '/recover/password/email',
        contentType: 'application/x-www-form-urlencoded',
        data: {email: $("#resetemail").val(), _token: token},
        success: function (r) {
            //hauriem de rebre '*ok*'
        }
    });
}


$(document).on(window.click_o_touch, ".reset_password_form", function (e) {
    e.preventDefault();
    if ((formcheck('resetPasswordForm'))) {
        reset_password_form();
    }
});


function reset_password_form() {
    $('#form-div').hide();
    $('#sent-div').fadeIn();

    var token = $('meta[name=csrf-token]').attr("content")


    $.ajax({
        method: 'POST',
        url: '/recover/password/reset',
        contentType: 'application/x-www-form-urlencoded',
        data: {
            email: $('input[name=resetexistingemail]').val(),
            domain_id: $('input[name=domain_id]').val(),
            password: $("input[name=resetpass]").val(),
            password_confirmation: $("input[name=resetpassconfirm]").val(),
            token: $("input[name=token]").val(),
            _token: token
        },
        success: function (r) {

            if (r == '*ok*') {
                window.location.replace("/");
                return;
            } else {
                if (window.log) console.log("error en reset pass");
                $('#form-div').hide();
                $('#error-div').fadeIn();
            }
            ;


        }
    });
}


/** FORM CHECK ******IGUAL A EMTYPE***************/

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


function clearAlert(e) {
    e.removeClass('form_alert');
    e.closest('.form-group').find('label').removeClass('form_alert');
    e.closest('.form-group').find('.fieldmessage').removeClass('form_alert');
}

function setAlert(e) {
    if (window.log) console.log('Alert: ' + e.attr('name'));

    e.addClass('form_alert');
    //ull! amb siblings no funciona x country (awesomplete)
    e.closest('.form-group').find('label').addClass('form_alert');
    e.closest('.form-group').find('.fieldmessage').addClass('form_alert');

}


function formcheck(idform, checklogin, pwdfield) {
    var errors = 0;
    var resp = '';
    var email = '';
    var pass = '';
    var minpwdlen = 6;

    //altres checks
    var form = $('#' + idform);
    checklogin = typeof checklogin !== 'undefined' ? checklogin : false;
    pwdfield = typeof pwdfield !== 'undefined' ? pwdfield : false;


    //si checklogin és true només verifiquem oldemail i password
    if (checklogin) {
        email = $(".oldemail", form);
        pass = $(".password", form);

        if (email.length && pass.length) {
            resp = $.ajax({
                type: "GET",
                data: {email: email.val(), password: pass.val()},
                url: '/customer/check-credentials',
                async: false
            }).responseText;
            if (resp == '*ok*') {
                return true;//tornem sense errors, continua login
            } else {
                setAlert(email);
                setAlert(pass);
                return false; //tornem amb errors
            }
        }

    }


    $('#' + idform + ' :input').each(function (i, e) {
        var e = $(e);
        clearAlert(e);
        if (e.hasClass('required') && !e.val().length) {
            setAlert(e);
            errors++;
        }

        if (e.hasClass('numeric') && e.val().length && !$.isNumeric(e.val())) {
            setAlert(e);
            errors++;
        }

        if ((e.hasClass('email') || e.hasClass('email_check') || e.hasClass('oldemail')) && e.val().length && !validateEmail(e.val())) {
            setAlert(e);
            errors++;
        }

    });


    //mirem si tenim password i password_check
    var pwd = $(".password", form);
    var pwd_c = $(".password_check", form);

    //canvi! no fem check de len minima si no son requireds!
    if (!pwd.hasClass('required') && !pwd_c.hasClass('required')) minpwdlen = 0;

    //si tenim les dos però no coincideixen, fixem form_alerta als dos camps
    //igualment si l'allargada del password és de menys de minpwdlen chars
    // if ((pwd.length && pwd_c.length && pwd.val() != pwd_c.val()) || (pwd.length && pwd.val().length < minpwdlen)) {

    //suprimim control allargada, ja ho fem despres
    if ((pwd.length && pwd_c.length && pwd.val() != pwd_c.val())) {
        setAlert(pwd);
        setAlert(pwd_c);
        errors++;
        //if(pwd.val().length<minpwdlen) if (window.log) console.log('pwd curt');
        //if (window.log) console.log('error en pwds');
    }


    //AFEGIM CONTROL ERRORS EN PASSWORD
    //si ens passen pwdfield per checkejar, el mirem abans de res
    if (pwdfield) {

        pass = $("#" + pwdfield, form);

        if (pass.length) {
            resp = $.ajax({
                type: "GET",
                data: {pwd: pass.val()},
                url: '/customer/check-password',
                async: false
            }).responseText;
            if (resp != '*ok*') {
                console.log(resp);
                setAlert(pass);
                errors++;
            }
        }
    }


    //mirem si tenim email i email_check, a més haurien de ser required!
    email = $(".email", form);
    var email_c = $(".email_check", form);
    //si tenim les dos però no coincideixen, fixem form_alerta als dos camps
    if (email.length && email_c.length && email.val() != email_c.val()) {
        setAlert(email);
        setAlert(email_c);
        errors++;
    }


    //mirem si mail existeix. ull! ajax sincron:
    if (email.length) {
        //if (window.log) console.log("mail:"+email.val());
        resp = $.ajax({
            type: "GET",
            data: {email: email.val()},
            url: '/customer/new-mail',
            async: false
        }).responseText;
        if (resp != '*mail_nou*') {

            //if (window.log) console.log(resp);
            setAlert(email);
            errors++;
        }
    }

    //fem mateixa consulta però ara per veure si un email existeix...
    var existingemail = $(".existingemail", form);
    //mirem si mail existeix. ull! ajax sincron:
    if (existingemail.length) {
        //if (window.log) console.log("mail:"+email.val());
        resp = $.ajax({
            type: "GET",
            data: {email: existingemail.val()},
            url: '/customer/new-mail',
            async: false
        }).responseText;
        if (resp != '*mail_existent*') {
            setAlert(existingemail);
            errors++;
        }
    }

    //ara si tenim country i vat_number
    country = $("[name='country']", form);
    vat_number = $("[name='vat_number']", form);

    if (country.length && vat_number.length) {
        //...
        //if (window.log) console.log(country);
        //if (window.log) console.log(vat_number);
    }

    return (errors == 0);
}


/*********** FOOTER TRIANGLE *************/
/** si place és un string busquem qui el te, si no es q directament ens passen element **/
function moveTriFo(place) {
    var $this;
    removeTriFo();
    if (typeof place == 'string') {
        $this = $("ul.footer-menu li span[url='" + place + "']");
    } else {
        $this = place;
    }
    if (!$this.length) return;
    var offset = $this.offset();
    if (offset) {
        var width = $this.width();
        var centerX = offset.left + width / 2;
        $('#tri-footer').css('left', centerX - 10);
    }
}

function removeTriFo() {
    if (window.log) console.log("movent!");
    $('#tri-footer').css('left', '-100px');

}


/******** FUNCIO DE PINTAR FONTS a vista fonts (/catalogues) **********/



function pintaFonts() {

    $('#lesfonts').empty();

    var afegit = '';
    var ii = 0;

    afegit += '<div class="row">';
    afegit += '<div class="col-lg-1 col-md-1 col-sm-1"></div>';

    $.each(window.dades, function (i, item) {

        //d'entrada item no es visible, s'ho ha de guanyar...
        item.visible = 0;

        //mirem primer si per Style es veu
        if (typeof window.mstyleoption == 'undefined' ||
            window.mstyleoption.indexOf('All') > -1 ||
            item.tagl.filter(function (n) {
                return window.mstyleoption.indexOf(n) != -1;
            }).length > 0
        ) {
            item.visible = 1;
        }

        //ara apliquem segon filtre als que han passat el primer...
        if (item.visible == 1 && typeof window.musageoption != 'undefined' &&
            window.musageoption.indexOf('All') == -1 &&
            item.tagl.filter(function (n) {
                return window.musageoption.indexOf(n) != -1;
            }).length == 0
        ) {
            item.visible = 0;
        }

        //finalment si visible pintem
        if (item.visible == 1) {
            ii++;
            if (window.log) console.log(window.mstyleoption + $.inArray(window.mstyleoption, item.tagl));

            afegit += '<div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 wrap">';
            afegit += '<span class="font-md font-red textline" ><span class="font-bold">' + item.numfonts
                + ' style' + ((item.numfonts > 1) ? 's' : '') + '</span></span>'

            afegit += '<div class="fontbox text-center">';
            afegit += '<a href="/fonts/' + item.slug + '">';

            afegit += '<img class="img-responsive fontexample" src="/img/catalogue/' + item.slug + '/' + item.img_file + '" />';
            afegit += '<img class="img-responsive fontexample nodisplay" src="/img/catalogue/' + item.slug + '/' + item.img_file_hover + '" />';

            //afegit += '<img class="img-responsive fontexample" src="/pic?d=' + item.domain_id + '&cat=' + item.id + '&slug=' + item.slug + '&img=' + item.img_file + '" />';
            //afegit += '<img class="img-responsive fontexample nodisplay" src="/pic?d=' + item.domain_id + '&cat=' + item.id + '&slug=' + item.slug + '&img=' + item.img_file_hover + '&hover=1" />';

            afegit += '</a>';

            afegit += '</div></div>';

            //si mod3 afegim una columna en blanc!
            if (ii % 3 == 0) {
                afegit += '</div>';
                afegit += '<div class="row">';
                afegit += '<div class="col-lg-1 col-md-1 col-sm-1"></div>';

            }
        }
    });
    afegit += '</div>';

    $('#lesfonts').html(afegit);

}


$(document).on(window.click_o_touch, ".hidefonts", function (e) {
    daltMenu();
    $('#fontfilter').slideUp();
});

$(document).on("mouseenter", ".open-font-filter", function (e) {
    daltCreuF();
    $('#fontfilter').slideDown();
});

$(document).on("mouseleave", ".fontbox", function (e) {
    $(this).closest('.wrap').find('.textline').css('visibility', 'hidden');
    $(this).find('.fontexample').toggleClass('nodisplay');
});

$(document).on("mouseenter", ".fontbox", function (e) {
    $(this).closest('.wrap').find('.textline').css('visibility', 'visible');
    $(this).find('.fontexample').toggleClass('nodisplay');
});


/* de fontfilter.blade */
/* de fontfilter.blade */

/* de fontfilter.blade */

function filtra() {
    var eltext;
    window.mstyleoption = [];
    window.musageoption = [];

    $('.mstyle.mactiu').each(function () {
        eltext = $(this).find('.valor').text();
        window.mstyleoption.push(eltext);
    });
    $('.musage.mactiu').each(function () {
        eltext = $(this).find('.valor').text();
        window.musageoption.push(eltext);
    });

    if (window.log) console.log(window.mstyleoption);
    if (window.log) console.log(window.musageoption);

    pintaFonts();

}


function pintactius() {
    $('.mactiu').each(function () {
        $(this).find('.marcador').remove();
        $(this).html('<span style="margin-right: 3px;" class="marcador"><img style="display: inline-block;" src="/img/icon_mark.png" /></span>' + $(this).html());
    });
}

$(document).on(window.click_o_touch, ".reset-filters", function () {
    $('.mitem').removeClass('mactiu').find('.marcador').remove();
    $('.allfonts').addClass('mactiu');
    pintactius();
    filtra();
});

$(document).on(window.click_o_touch, ".mstyle", function () {
    if ($(this).hasClass('allfonts')) {
        $('.mstyle').removeClass('mactiu').find('.marcador').remove();
        $(this).addClass('mactiu');
    } else {
        $('.mstyle.allfonts').removeClass('mactiu').find('.marcador').remove();
        $(this).toggleClass('mactiu').find('.marcador').remove();
    }
    pintactius();
    filtra();
});

$(document).on(window.click_o_touch, ".musage", function () {
    if ($(this).hasClass('allfonts')) {
        $('.musage').removeClass('mactiu').find('.marcador').remove();
        $(this).addClass('mactiu');
    } else {
        $('.musage.allfonts').removeClass('mactiu').find('.marcador').remove();
        $(this).toggleClass('mactiu').find('.marcador').remove();
    }
    pintactius();
    filtra();
});


//depenent de si tenim o no el topcaption la posició fixa del menu de fonts canvia...
function showFontMenu() {

    /*si som a XS no mostrem! */
    if ($('#div-xs').is(':visible')) return;

    var altpos = $(".top-area").css("height").replace(/[^0-9]/g, '') * 1;
    var leftpos = $("#left-reference").offset().left;

    var extramargetop = 80;

    if ($('.topcaption').is(':visible')) {
        altpos += $(".topcaption").css("height").replace(/[^0-9]/g, '') * 1;
    }

    leftpos += 6; //padding col?
    altpos += 15; //extra padding sota topcaption
    altpos += extramargetop;

    if (window.log) console.log('FontMenu @ ' + leftpos + ',' + altpos);

    $('#fontmenu').css('top', altpos + 'px').css('left', leftpos + 'px');
    $('#fontmenu').show();
}


$(document).on(window.click_o_touch, "#openFontMenu", function (e) {
    if (window.log) console.log("obrint les fonts...");

    var theLayer = $("#theModal");
    var theContent = theLayer.find(".theColumn");


    if (theLayer.is(':visible')) {

        theContent.html('');
        theLayer.fadeOut();


    } else {

        var footer = $('.footer-area');
        var alt_footer = footer.offset().top - 60 + footer.outerHeight();
        var alt_content = ($('#theContent').css('height').match(/\d+/)[0] * 1) + 60;
        var alt_final = (alt_footer > alt_content) ? alt_footer : alt_content;

        var ct = $("#ul-wrapper").html();

        theLayer.css('min-height', alt_final + 'px'); //60 es espai entre footer i final content

        theContent.html('');
        theContent.html(ct);

        $("html, body").animate({scrollTop: 0}, "fast");

        theLayer.fadeIn();
    }

    // $(this).show();

});


/*** PROCEDENTS DE CATALOGUE.BLADE  ****/


$(document).on("change", ".mida", function (e) {
    $(this).closest('div.font-box').find('.livefont').css('font-size', $(this).val() + 'px').find('span').css('font-size', $(this).val() + 'px');
});

$(document).on(window.click_o_touch, ".completa", function (e) {
    e.preventDefault();

    //ull! abans es solicitava confirmació, ara tirem pel dret
    $cat = $("#catalogueId").val();
    //true indica q param es cataleg i volem la seva familia complerta
    addBundleToCart($cat, true);

    $(this).closest('div').html('<a href="/cart" class="btn btn-empty font-md font-bold text-uppercase">FAMILY IN CART</a>');


    return;

    /*
    $('#askmsg-modal').html('Add Complete Family to Cart?');
    $('#ok-caption-modal').html('Yes');

    $('#ask-modal').show();
    */
});


$(document).on(window.click_o_touch, ".ok-modal", function (e) {
    e.preventDefault();
    $('.modal').hide();
    $cat = $("#catalogueId").val();
    //true indica q param es cataleg i volem la seva familia complerta
    addBundleToCart($cat, true);
});

$(document).on(window.click_o_touch, ".buy", function (e) {
    e.preventDefault();
    var fontid = $(this).attr('data-font');
    if (window.log) console.log('Buy font:' + fontid);
    var qtt = 1; //per defecte qtt mínima
    if (window.log) console.log('cridem font to cart...');
    addFontToCart(fontid);
});


$(document).on(window.click_o_touch, ".buy-bundle", function (e) {
    var bundleid = $(this).attr('data-bundle');
    if (window.log) console.log('Buy bundle:' + bundleid);
    addBundleToCart(bundleid);
});

$(document).on(window.click_o_touch, ".livefont", function (e) {
    $('.sizeline').css('visibility', 'hidden');
    $(this).closest('.font-box').find('.sizeline').css('visibility', 'visible');
});


/**
 * mostra text llarg quan cliquem generate
 */
$(document).on(window.click_o_touch, ".generate", function (e) {

    var fontbox = $(this).closest('div.font-box');
    var livefont = fontbox.find('.livefont');

    var text = '';
    var curtext = '';
    var size = 0;
    var mida = fontbox.find('.mida');
    var linalt = '';
    var mtop = '';
    var mbottom = '';
    var estil = null;


    $(this).toggleClass('font-gris60 folded');

    if ($(this).hasClass('folded')) {
        $(this).closest('li').find('.xabanda').hide();
        /* TEXT DEMO GRAN/CURT */
        curtext = livefont.css('font-size', size).text();
        fontbox.find('.demotext_long').text(curtext);
        fontbox.find('.midatext_long').text(mida.val());
        //separació control-panel
        text = fontbox.find('.demotext').text();
        size = fontbox.find('.midatext').text();

        estil = fontbox.find('.inistyle').text().replace(/ /g, '').split(';');
        if (window.log) console.log('estil: ' + fontbox.find('.inistyle').text());

        estil.forEach(function (el) {
            if (window.log) console.log(el);
            if (el.indexOf('line-height:') > -1) {
                linalt = el.substr(12);
            }
            if (el.indexOf('margin-top:') > -1) {
                mtop = el.substr(11);
            }
            if (el.indexOf('margin-bottom:') > -1) {
                mbottom = el.substr(14);
            }

        });
        if (linalt.length) livefont.css('line-height', linalt);
        if (mtop.length) livefont.css('margin-top', mtop);
        if (mbottom.length) livefont.css('margin-bottom', mbottom);

        if (window.log) console.log('nova size updatada:' + size);
        mida.jRange('updateRange', '18,250', size);

    } else {
        $(this).closest('li').find('.xabanda').show();
        /* TEXT DEMO PETIT/LLARG */
        curtext = livefont.css('font-size', size).text();
        fontbox.find('.demotext').text(curtext);
        fontbox.find('.midatext').text(mida.val());
        text = fontbox.find('.demotext_long').text();
        __text = '<div class="row"><div class="col-lg-2 col-md-2 col-sm-1 col-xs-1"></div><div class="col-lg-6 col-md-6 col-sm-8 col-xs-8 text-left paragraf">'
            + text + '</div></div>';

        size = fontbox.find('.midatext_long').text();
        //if (window.log) console.log('mida nova:'+size);
        livefont.css('line-height', '1.3em');
        livefont.css('margin-top', '10px');
        livefont.css('margin-bottom', '20px');

        if (window.log) console.log('nova size updatada:' + size);
        mida.jRange('updateRange', '18,60', size);
    }

    livefont.css('font-size', size + 'px');
    livefont.html(text);
});


/***** FINS AQUI CATALOGUE.BLADE ********/


/********* RESIZE FONTS **********/

/**
 *
 * FONTS LIVE RESPONSIVES
 *
 *  ...max_screen *** (maxratio)
 *                   *
 *                    *
 *                     *
 *                      *
 *            (minratio) ********** min_screen...
 *
 *   ...1200px ****** (100%)
 *                   *
 *                    *
 *                     *
 *                      *
 *                 (30%) ********** 480px....
 *
 *
 * Procediment per ajustar la mida de les fonts de la portada i les de les caixes editables
 * segons la mida de la pantalla, partint de 1200 i fins a 480
 * Tot el més gran de 1200px ample es mostra al 100% de la mida determinada al backoffice
 * i tot el menor de 480px ample es mostra al 30% d'aquesta
 * les mides intermitges es calculen proporcionalment (segons gràfica anterior)
 *
 *
 *
 */

var rtime;
var timeout = false;
var delta = 200;
/* ms de espera entre events resize */

var max_screen = 1200;
var min_screen = 480;
var minratio = 30;
var maxratio = 100;

/* old_ample i old_ratio son els anteriors a l'actual, per saber si esteem augmentant o baixant */

window.old_ample = 0;
window.old_ratio = 0;


/* captura event window.resize */
$(window).resize(function () {
    if (window.enableResizeFonts == null || !window.enableResizeFonts) return;
    if (window.old_ample == 0) {
        var ample = $(window).width();
        window.old_ample = ample;
        if (ample >= max_screen) window.old_ratio = maxratio;
        else if (ample <= min_screen) window.old_ratio = minratio;
        else window.old_ratio = minratio + (maxratio - minratio) * (ample - min_screen) / (max_screen - min_screen);
    }
    rtime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(resizeFonts, delta);
    }
});


/**
 *
 * funcio que canvia la mida de les fonts
 *
 */
function resizeFonts() {

    if (!window.force_resize && new Date() - rtime < delta) {
        setTimeout(resizeFonts, delta);
    } else {


        timeout = false;
        var modifica_marges = true;

        //les ratios sempre son les mateixes per tota la pàgina
        //depenen de la mida màxima, la mínima i les ràtios màxima i mínima
        var ample = $(window).width();
        var ratio = 0;
        if (ample >= max_screen) ratio = maxratio;
        else if (ample <= min_screen) ratio = minratio;
        else ratio = minratio + (maxratio - minratio) * (ample - min_screen) / (max_screen - min_screen);


        $(".livefont").each(function () {
            //var actual_size = $(this).css('font-size').match(/\d+/)[0];
            //var actual_margin_top = $(this).css('margin-top').match(/\d+/)[0];
            //var actual_margin_bottom = $(this).css('margin-bottom').match(/\d+/)[0];

            var actual_size = $(this).css('font-size').replace('px', '') * 1.0;
            var actual_margin_top = $(this).css('margin-top').replace('px', '') * 1.0;
            var actual_margin_bottom = $(this).css('margin-bottom').replace('px', '') * 1.0;

            // calculem la nova mida a partir de l'actual * (ration nova/ratio vella)
            // ens hi obliga el fet que l'usuari pot canviar la mida del text, de manera que no podem
            // referir-nos a la mida original i calcular a partir d'aquella
            // cal fer el canvi de mida sempre incremental (a les livefonts)

            var novamida = Math.floor(actual_size * ratio / window.old_ratio);
            var noumargintop = Math.floor(actual_margin_top * ratio / window.old_ratio);

            //if (window.log) console.log('Margintop: '+actual_margin_top+'>>>'+noumargintop);
            var noumarginbottom = Math.floor(actual_margin_bottom * ratio / window.old_ratio);
            if (window.log) console.log(actual_size + ' >>> ' + novamida + ' (' + window.old_ample + ' >> ' + ample + ')');

            if ($('#div-xs').is(":visible")) {
                $(this).css('font-size', novamida + 'px');
                if (modifica_marges) {
                    $(this).css('margin-top', noumargintop + 'px');
                    $(this).css('margin-bottom', noumarginbottom + 'px');
                }
            }
            else {
                if (modifica_marges) {
                    $(this).css('margin-top', noumargintop + 'px');
                    $(this).css('margin-bottom', noumarginbottom + 'px');
                }
                $(this).closest('.font-box').find('.mida').jRange('setValue', novamida + '');
            }

        });

        //repetim mateix procés per les fonts de la portada

        $(".homefont").each(function () {
            var actual_size = $(this).css('font-size').match(/\d+/)[0];

            // calculem la nova mida a partir de l'actual * (ration nova/ratio vella)
            // ens hi obliga el fet que l'usuari pot canviar la mida del text, de manera que no podem
            // referir-nos a la mida original i calcular a partir d'aquella
            // cal fer el canvi de mida sempre incremental (a les livefonts)

            var novamida = Math.floor(actual_size * ratio / window.old_ratio);
            if (window.log) console.log(actual_size + ' >>> ' + novamida + ' (' + window.old_ample + ' >> ' + ample + ')');

            $(this).css('font-size', novamida + 'px');

            //$(this).closest('.font-box').find('.mida').jRange('setValue', novamida + '');

        });

        //resizem glyphs!
        glyphResize();


        window.old_ample = 0;
        window.force_resize = false;

    }
}


/**
 * NOU GLYPHRESIZE
 * l'anterior falla en firefox
 * ha calgut canviar la forma com es pinten els textos del glyph en catalogue-glyphscontent.blade
 * per tal de tancar els blocs de text dins spans i així poder llegir el width del text i la hr per separat
 * els blocs es marquen amb class="glyphs-part" (tot i que no caldria, podriem mirar el primer span)
 *
 * l'anterior mètode de càlcul es basava en el que el width del bloc era el de la primera lína de text que
 * és com calcula tothom excepte firefox, que mira l'element més ample del bloc (en aquest cas HR)
 * l'anterior sistema sempre donava la mateixa mida del text que del hr
 *
 * @todo es podria millorar cercant ample més gran de tots els blocs (tal com funció antiga més avall)
 *
 */




function glyphResize() {

    // CANVI DE MIDA DELS GLYPHS, VERSIO MILLORADA
    // nomes si tenim glyphtab!

    if (window.log) console.log('Glyphs');

    var tab = $(".glyph-tab:visible");
    if (tab.length) {
        if (window.log) console.log('...resizing');
        var theWrap = tab.find('.glyph-wrap');
        theWrap.css('visibility', 'hidden');

        var ampletext = theWrap.find('span.glyphs-part:first').width();

        /* versió millorada, verifica ample de totes les linies i es queda amb el més gran */
        theWrap.find('span.glyphs-part').each(function () {
            if ($(this).width() > ampletext) {
                ampletext = $(this).width();
            }
        });

        var amplehr = theWrap.find('hr:first').width();
        var actual_size = tab.find('div').css('font-size').match(/\d+/)[0];
        var novamida = Math.floor(actual_size * amplehr / ampletext);

        tab.find('div.glyph-wrap').css('font-size', novamida + 'px');
        if (window.log) console.log('glyphs: ' + actual_size + ' >>> ' + novamida + ' (' + ampletext + ' >> ' + amplehr + ')');

        //per evitar el lag els glyphs part inicialment son ocults i després apareixen...
        theWrap.css('visibility', 'visible');

    }

}


/**
 * permet preguntar si estem en xs, lg, md, sm
 *
 * if wearein('xs') {...}
 *
 * @param res
 * @returns {*|jQuery}
 */
function wearein(res) {

    return $('#div-' + res).is(':visible');

}